import React from 'react'

const SpecificationsCell = ({ value, className }) => {
    return <p className={className}>{value}</p>
}

export default SpecificationsCell
